import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import { Jalur } from "@/types"
import SkeletonTable from "@/components/SkeletonTable"
import { getListKepemilikanAset } from "@/services/getData"

export interface JalurResponse {
  data: Jalur[]
}

export default function MasterKepemilikanAssetPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listKepemilikanAset"],
    queryFn: getListKepemilikanAset,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
